import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { captureUTMParameters } from './lib/analytics'
import { initGA4 } from './lib/ga4'

// Initialize GA4 using the measurement ID from the connected Google Analytics account
initGA4();

// Capture UTM parameters on first page load for attribution tracking
captureUTMParameters();

createRoot(document.getElementById("root")!).render(<App />);
